export const setHeaderTitleAction = (title) => ({
  type: 'SET_TITLE',
  payload: title
});

/***
 * @param {Boolean} [credits]
 * @param {Boolean} [back]
 * @param {Boolean} [exit]
 * @param {Boolean} [logo]
 * @param {Boolean} [settings]
 * @param {Boolean} [drawer]
 * @param {Boolean} [notification]
 * @returns {{payload: {exit, settings, notification, credits, back, logo, drawer}, type: string}}
 */
export const setHeaderConfigsAction = ({
  credits,
  back,
  exit,
  logo,
  settings,
  drawer,
  notification
}) => {
  const data = {
    credits: credits ?? true,
    back: back ?? false,
    exit: exit ?? false,
    logo: logo ?? false,
    settings: settings ?? false,
    drawer: drawer ?? false,
    notification: notification ?? false
  };

  return {
    type: 'TOGGLE_CONFIGS',
    payload: data
  };
};
